import { FC } from "react";
import { NavbarNew } from '../LandingNavbar';
import { Hero } from '../LandingHero';
import { Services } from '../LandingServices';
import { Contact } from '../LandingContactNew';
import { Footer } from '../LandingFooterNew';


import "../Resources/style.css";

const Landing: FC = () => {

    return (
        <>
            <div className="min-h-screen">
                <NavbarNew />
                <Hero />
                <Services />
                <Contact />
                <Footer />
            </div>
        </>
    );

};

export default Landing;
